/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{getAssetUrl as t}from"../../assets.js";function s(){return n??=(async()=>{const s=await import("../../chunks/i3s.js");return await s.default({locateFile:s=>t(`esri/libs/i3s/${s}`)})})(),n}function i(){n=null}let n;export{i as cleanup,s as get};
